var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "append-to-body": "",
          },
          on: {
            open: _vm.open,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { attrs: { prop: "product_key" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("产品")]),
                  ]),
                  _c("v-select", {
                    attrs: {
                      id: "product_key",
                      name: "product_key",
                      placeholder:
                        _vm.productOptins.length > 0
                          ? "请选择"
                          : "请先新建产品",
                      options: _vm.productOptins,
                    },
                    model: {
                      value: _vm.ruleForm.product_key,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "product_key", $$v)
                      },
                      expression: "ruleForm.product_key",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "dev_name" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("设备名称")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "dev_name" },
                    model: {
                      value: _vm.ruleForm.dev_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "dev_name", $$v)
                      },
                      expression: "ruleForm.dev_name",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "dev_key" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("设备KEY")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "dev_key" },
                    model: {
                      value: _vm.ruleForm.dev_key,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "dev_key", $$v)
                      },
                      expression: "ruleForm.dev_key",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "dev_mac" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("设备MAC")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "dev_mac" },
                    model: {
                      value: _vm.ruleForm.dev_mac,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "dev_mac", $$v)
                      },
                      expression: "ruleForm.dev_mac",
                    },
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c("v-loading", {
            staticClass: "loading-box",
            attrs: { visible: !_vm.upTips, name: "loading4" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }